"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_LARGE_DATA_POLICY = void 0;
/** Page part sizing; calibrated independently from database row shards. */
exports.PAGE_LARGE_DATA_POLICY = {
    part: {
        targetBytes: 256 * 1024,
        hardBytes: 1024 * 1024,
        canvasJoinDistance: 2048,
    },
};
